/**
 * Relative timestamp formatter for the notifications list.
 *
 * Notification rows expose `created_at` (TIMESTAMPTZ, NOT NULL DEFAULT NOW()).
 * Guards against null/undefined/unparseable input so a missing or malformed
 * value renders a dash instead of the literal string "Invalid Date".
 */
function formatTimestamp(value) {
  if (value == null) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';

  const diff = Date.now() - date.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;

  return date.toLocaleDateString();
}

module.exports = { formatTimestamp };
